import { render, staticRenderFns } from "./Curtain.vue?vue&type=template&id=c7047f8e&scoped=true&"
import script from "./Curtain.vue?vue&type=script&lang=js&"
export * from "./Curtain.vue?vue&type=script&lang=js&"
import style0 from "./Curtain.vue?vue&type=style&index=0&id=c7047f8e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7047f8e",
  null
  
)

export default component.exports